import {
	faArrowUpFromBracket,
	faFile,
	faFolder,
	faTimes,
} from '@netx/core-icons';

export const UPLOAD_ASSET_ACTION_ICON = <const>{
	GOTO_ASSET: faFile,
	GOTO_FOLDER: faFolder,
	REMOVE: faTimes,
	STATUS: faArrowUpFromBracket,
	UPLOAD: faArrowUpFromBracket,
};

export type UploadAssetBaseEvent = typeof UPLOAD_ASSET_BASE_EVENT;

export const UPLOAD_ASSET_BASE_EVENT = `upload:asset`;

export const UploadAssetEvent = <const>{
	GOTO_ASSET: `${UPLOAD_ASSET_BASE_EVENT}:goto:asset`,
	GOTO_FOLDER: `${UPLOAD_ASSET_BASE_EVENT}:goto:folder`,
	IMPORT_ERROR: `${UPLOAD_ASSET_BASE_EVENT}:error`,
	IMPORT_FAILURE: `${UPLOAD_ASSET_BASE_EVENT}:failure`,
	IMPORT_SUCCESS: `${UPLOAD_ASSET_BASE_EVENT}:success`,
	IMPORT_WARNING: `${UPLOAD_ASSET_BASE_EVENT}:warning`,
	REMOVE: `${UPLOAD_ASSET_BASE_EVENT}:remove`,
	STATUS: `${UPLOAD_ASSET_BASE_EVENT}:status`,
	UPLOAD: `${UPLOAD_ASSET_BASE_EVENT}:upload`,

	REIMPORT: `${UPLOAD_ASSET_BASE_EVENT}:reimport`,
};
